import { ReactElement } from "react";
import { ListElement, SpinnerLegacy } from "../../../../components";
import { NavigationBarMenu } from "../../../../components/navigation/NavigationBar";
import { PageContainer } from "../../../../components/pageContainer/PageContainer";
import { useDraftOrders } from "../../../../hooks/api/v2/useDraftOrders";
import { DraftOrderItem } from "./components/DraftOrderItem/DraftOrderItem";
import { useDraftOrderList } from "../../../../hooks/api/v2/draft-order/useDraftOrderList";
import { IntersectingInfiniteLoadingButton } from "../../../../components/infiniteLoading/IntersectingInfiniteLoadingButton";

export const DraftOrders = (): ReactElement => {
  const { orders: draftOrders } = useDraftOrders();

  const supplierIdList =
    draftOrders?.map((order) => order.SupplierId).filter(Boolean) ?? [];

  const draftOrderListQuery = useDraftOrderList(
    {
      query: [
        {
          type: "supplierIdList",
          modifier: "IN",
          value: supplierIdList,
        },
      ],
      limit: 20,
    },
    {
      enabled: !!supplierIdList.length,
    },
  );

  return (
    <>
      <NavigationBarMenu title={"Draft orders"} />
      {draftOrderListQuery.isLoading || !draftOrders ? (
        <SpinnerLegacy />
      ) : (
        <PageContainer>
          <div className="flex flex-col gap-4 bg-neutral-100 px-2 py-4">
            {!draftOrderListQuery.data?.pages.length || !draftOrders ? (
              <ListElement>No draft orders.</ListElement>
            ) : (
              draftOrderListQuery.data.pages.map((page) =>
                page.map((supplierStorefrontInfo) => {
                  const draftOrder = draftOrders
                    .filter((draftOrder) => !draftOrder.sdBasketId)
                    .find(
                      (draftOrder) =>
                        draftOrder.SupplierId ===
                        supplierStorefrontInfo.supplier.id,
                    );

                  if (!draftOrder) {
                    return null;
                  }

                  return (
                    <DraftOrderItem
                      key={supplierStorefrontInfo.supplier.id}
                      order={draftOrder}
                      supplierStorefrontInfo={supplierStorefrontInfo}
                    />
                  );
                }),
              )
            )}
          </div>
        </PageContainer>
      )}
      <IntersectingInfiniteLoadingButton query={draftOrderListQuery} />
    </>
  );
};
